// extracted by mini-css-extract-plugin
export default {"detail":"DetailPaymentHistory_detail__-G8sm","title":"DetailPaymentHistory_title__krOgy","fields":"DetailPaymentHistory_fields__noseQ","button":"DetailPaymentHistory_button__qzCAN"};